import React from 'react';
import { useNotifications } from '@fullstory/react-hooks';
import { SendSnippetForm } from '../SendSnippetForm';
import { dispatchSendSnippet } from '../../utils/util';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@fullstory/redux';
import { Modal } from '@fullstory/components';
import { FormattedMessage } from 'react-intl';

interface SendSnippetModalContainer
  extends Omit<React.ComponentProps<typeof SendSnippetForm>, 'onSubmit'> {
  onSnippetSent: () => void;
  onCloseSignal: React.ComponentProps<typeof Modal>['onCloseSignal'];
}

export const SendSnippetModalContainer: React.FC<SendSnippetModalContainer> = ({
  onSnippetSent,
  onCloseSignal,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const notifications = useNotifications();

  const handleSubmit = (email: string, message: string, invite: boolean) => {
    dispatchSendSnippet(email, message, invite, dispatch, notifications, onSnippetSent);
  };

  return (
    <Modal size="small" onCloseSignal={onCloseSignal}>
      <Modal.Header onCloseSignal={onCloseSignal}>
        <FormattedMessage defaultMessage="Send your snippet to a teammate" id="1V3/qT" />
      </Modal.Header>
      <Modal.Body>
        <SendSnippetForm showInviteOption={false} onSubmit={handleSubmit} mode="snippet" />
      </Modal.Body>
    </Modal>
  );
};
